<template>
	<iframe :src="mapEmbedLink" height="450" style="border:0; width: 100%;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</template>
<script>
export default {
	props: ["address", "mapLink", "locationName"],
	data() {
		return {
			mapEmbedLink: "https://www.google.com/maps/embed/v1/place?key=AIzaSyBANU1W37pzHglalpcLjEm4WUHQmG7mqXk&q=",
		}
	},
	created() {
		if(this.mapLink)
			this.googleMapsURLToEmbedURL(this.mapLink);
		else
			this.mapEmbedLink = this.mapEmbedLink + this.address + " - " + this.locationName;
	},
	methods: {
		googleMapsURLToEmbedURL(GoogleMapsURL) {
				var name = GoogleMapsURL.slice(GoogleMapsURL.indexOf('place/')+6, GoogleMapsURL.indexOf('/@'));
				var coords = [GoogleMapsURL.slice(GoogleMapsURL.indexOf('!3d')+3, GoogleMapsURL.indexOf('!4d')), GoogleMapsURL.slice(GoogleMapsURL.indexOf('!4d')+3, GoogleMapsURL.indexOf('!16s'))];
				if(coords!=null)
					this.mapEmbedLink = this.mapEmbedLink + coords[0] + "," + coords[1] + "!2s"+name;
		}
	},
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/blumar-map/BlumarMap.vue